import {ERROR, LOADING, LOGGED_OUT, SIGN_IN, SIGN_IN_TOKEN_REQUIRED, SIGNED_IN} from "module/constants";
import common from "module/common";
import AuthorisationError from "module/error/AuthorisationError";
import socket from 'module/socket';
import Cookies from 'js-cookie';

const LOGGED_IN_USER = 'loggedInUser';

const SET_STATE = 'loggedInState';
const SET_STATE_REASON = 'loggedInStateReason';

const SET_LOGGED_IN_USER = 'loggedInUser';
const SET_ALL_USERS = 'allUsers';

const RESET_LOGGED_IN_USER = 'resetLoggedInUser';

export const actions = {
  initEmailToken({commit, dispatch, state}) {
    commit(SET_STATE, LOADING);
    if (Cookies.get(SESSION_AUTHORIZED) === undefined) {
      commit(SET_STATE, SIGN_IN);
      dispatch('initAllLoginMethods');
      return;
    }

    return common
      .httpPost('verify')
      .data({})
      .then((res) => {
        commit(SET_STATE, SIGNED_IN);
        commit(SET_LOGGED_IN_USER, res.data.loggedInUser);
        dispatch('brand/load', null, {root: true});
      }, (error) => {
        console.log(error);
        if (error instanceof AuthorisationError && error.data.code === 401) {
          //user is not logged in
          commit(SET_STATE, SIGN_IN);
          dispatch('initAllLoginMethods');
        } else {
          //some other error
          commit(SET_STATE, ERROR);
          dispatch('initAllLoginMethods');
        }
      });
  },
  sendConfirmation({state, commit, dispatch}, email) {
    commit(SET_STATE, LOADING);

    common
      .httpPost('user')
      .recaptchaAction('sendConfirmation')
      .data({login: 'sendConfirmation', email})
      .then((res) => {
        commit(SET_STATE, SIGN_IN_TOKEN_REQUIRED);
      }, (error) => {
        dispatch('error/error', error, {root: true});
        commit(SET_STATE, ERROR);
        commit(SET_STATE_REASON, _.get(error, 'data.message', null));
      });
  },
  sendResetPasswordEmail({state, commit, dispatch}, email) {
    commit(SET_STATE, LOADING);

    common
      .httpPost('user')
      .recaptchaAction('sendResetPasswordEmail')
      .data({login: 'sendResetPasswordEmail', email})
      .then((res) => {
        commit(SET_STATE, SIGN_IN_TOKEN_REQUIRED);
      }, (error) => {
        dispatch('error/error', error, {root: true});
        commit(SET_STATE, ERROR);
        commit(SET_STATE_REASON, _.get(error, 'data.message', null));
      });
  },
  confirmLogin({state, commit, dispatch}, {email, token}) {
    common
      .httpPost('user')
      .recaptchaAction('confirmLogin')
      .data({login: 'confirmLogin', email, token})
      .then((res) => {
        commit(SET_STATE, SIGNED_IN);
        commit(SET_LOGGED_IN_USER, res.data.loggedInUser);
        dispatch('brand/load', null, {root: true});
        dispatch('externalProvider/load', null, {root: true});
        dispatch('reportPack/load', null, {root: true});
        socket.validate();
      }, ({response}) => {
        commit(SET_STATE, ERROR);
        if (response && response.body && response.body.message) {
          commit(SET_STATE_REASON, response.body.message);
        }
      });
  },
  legacyUserManageSave({commit,dispatch}, user){
    common
      .httpPost('externalUser')
      .data({
        manage: user.isNew === true ? 'addUser' : 'updateUser',
        existingEmail: user.existingEmail,
        name: user.name,
        email: user.email,
        groups: user.groups,
        limitations: user.limitations
      })
      .then((res) => {
        commit(SET_ALL_USERS, res.data.all);
      }, ({response}) => {
        dispatch('error/error', error, {root: true});
      });
  }
};

export const getters = {
  canManageUsers(state) {
    return state.loggedInUser.user.limitations.filter(({limit}) => limit === 'MANAGE_USERS').length >= 1
  }
};